// extracted by mini-css-extract-plugin
export default {"container":"l_abUY","ratioImage":"JP9NVc","content":"PcQp24"};